module.exports = __webpack_public_path__ + "../resources/img/button_mappertext_delete.d6631c64.svg";